import { render, staticRenderFns } from "./IncreaseIcon.vue?vue&type=template&id=74b1c1e4&"
import script from "./IncreaseIcon.vue?vue&type=script&lang=js&"
export * from "./IncreaseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports